import React, { useState } from "react";
import log from "loglevel";
import { Modal, Container, Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { options } from "util/reactTableFuncs";
import { RolePermission } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const RolePermissionsCard = ({
  rolePermissions
}: {
  rolePermissions: RolePermission[];
}) => {
  const [selectedRolePermission, setSelectedRolePermission] = useState<
    RolePermission
  >();
  const [showInfoModal, setShowInfoModal] = useState(false);

  const rolePermissionsTable = (rolePermissions: RolePermission[]) => {
    const { SearchBar } = Search;
    const columns = [
      {
        dataField: "permission_name",
        text: "Permission",
        sort: true,
        headerAlign: "left",
        align: "left"
      },
      {
        dataField: "role_name",
        text: "Role",
        headerAlign: "left",
        align: "left"
      }
    ];
    const rowEvents = {
      onClick: (e: any, row: RolePermission, rowIndex: number) => {
        log.info("Row Index: " + rowIndex);
        log.info("Row: " + JSON.stringify(row));
        setSelectedRolePermission(row);
        setShowInfoModal(true);
      }
    };
    const dataSorted = rolePermissions.sort((a, b) =>
      a.permission_name.localeCompare(b.permission_name)
    );
    return (
      <>
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <div>
              <div className={styles["table__search-container"]}>
                <SearchBar
                  className={styles["table__search-container__search-bar"]}
                  {...props.searchProps}
                />
              </div>
              <div className={Table.classNames.table}>
                <BootstrapTable
                  {...props.baseProps}
                  bordered={false}
                  bootstrap4
                  hover
                  condensed
                  rowEvents={rowEvents}
                  pagination={paginationFactory(options)}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </>
    );
  };

  return (
    <>
      {rolePermissions ? rolePermissionsTable(rolePermissions) : null}
      {/* Permissions Settings Modal */}
      <>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showInfoModal}
          onHide={() => {
            setShowInfoModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Role Permission <FontAwesomeIcon icon={["far", "info-circle"]} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedRolePermission ? (
              <>
                <span className="font-bold">
                  {selectedRolePermission.permission_name}
                </span>
                <span> - {selectedRolePermission.role_name} is allowed</span>
              </>
            ) : null}
          </Modal.Body>
        </Modal>
      </>
    </>
  );
};

export default RolePermissionsCard;
